import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { Alert, AlertDescription, AlertTitle } from "./ui/alert";

export const NoData = () => {
	return (
		<Alert variant="destructive">
			<ExclamationTriangleIcon className="h-4 w-4" />
			<AlertTitle>Missing data</AlertTitle>
			<AlertDescription>There is no data to show.</AlertDescription>
		</Alert>
	);
};
